import { createTransform } from 'redux-persist'

import { PLACEMENT } from './appSlice'

const recipeKeys = [
  'washBakeRecipeOutput',
  'frameWorkRecipeOutput',
  'dentinRecipeOutput',
  'internalEffectOutput',
  'enamelRecipe',
  'materialAdviceOuput',
  'gingivaRecipeOutput',
  'gingivaCeramicOutput',
  'opaquerStainingOutput',
  'opaquerRecipe',
  'stumpShadeRecipeOutput',
]
const placementRecipes = [
  'stainingCorrectionRecipe',
  'stainingRecipe',
  'stumpShadeRecipe',
]

type GenericState = Record<string, any>

export const expireTransform = createTransform<GenericState, GenericState>(
  (inboundState) => inboundState,

  (outboundState) => {
    const now = Date.now()

    recipeKeys.forEach((recipeKey) => {
      const recipeGroup = outboundState?.[recipeKey]
      if (!recipeGroup) return

      Object.keys(recipeGroup).forEach((imageId) => {
        const node = recipeGroup[imageId]
        if (!node) return

        if (node?.expiresAt) {
          if (node.expiresAt < now) {
            delete recipeGroup[imageId]
          }
        } else if (typeof node === 'object') {
          Object.entries(node).forEach(([k, val]: [string, any]) => {
            if (val?.expiresAt && val.expiresAt < now) {
              delete node[k]
            }
          })
          if (Object.keys(node).length === 0) {
            delete recipeGroup[imageId]
          }
        }
      })
    })

    placementRecipes.forEach((recipeKey) => {
      const groupObj = outboundState?.[recipeKey]
      if (!groupObj) return
      ;[PLACEMENT.LEFT, PLACEMENT.RIGHT].forEach((placement) => {
        const group = groupObj[placement]
        if (!group) return

        Object.entries(group).forEach(([k, val]: [string, any]) => {
          if (val?.expiresAt && val.expiresAt < now) {
            delete group[k]
          }
        })

        if (Object.keys(group).length === 0) {
          delete groupObj[placement]
        }
      })

      if (Object.keys(groupObj).length === 0) {
        delete outboundState[recipeKey]
      }
    })

    return outboundState
  },
)
